module.exports = __webpack_public_path__ + "static/media/kg.b326e46f.svg";